import { configs } from '../../server/RestClients';

import {
  CLEAR_PREDICTIONS_LIST,
  GET_PREDICTION_FAILURE,
  GET_PREDICTION_LOADING,
  GET_PREDICTION_SUCCESS,
  GET_PREDICTIONS_FAILURE,
  GET_PREDICTIONS_SUCCESS,
} from '../actions/predictions';

const defaultState = {
  predictions: new Array(configs.length),
  loading: false,
  error: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_PREDICTION_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_PREDICTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case GET_PREDICTIONS_SUCCESS:
      return {
        predictions: action.payload,
        loading: false,
        error: false,
      };
    case GET_PREDICTION_SUCCESS: {
      const { prediction, i } = action.payload;
      const predictions = [...state.predictions];
      predictions[i] = prediction;
      return {
        loading: false,
        error: false,
        predictions,
      };
    }
    case GET_PREDICTION_FAILURE:
      return {
        loading: false,
        predictions: new Array(configs.length),
        error: action.payload,
      };
    case CLEAR_PREDICTIONS_LIST: {
      const predictions = [...state.predictions];
      const { i } = action.payload;
      predictions[i] = undefined;
      return {
        loading: false,
        error: false,
        predictions,
      };
    }
    default:
      return state;
  }
};

export const loadingPredictionsSelector = (state) => state.predictions.loading;
export const predictionsSelector = (state) => state.predictions.predictions;
